module.exports = __webpack_public_path__ + "img/kodit.69d73e03.svg";